export default "__VITE_ASSET__B3mb_yF3__"